<template>

    <!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
                    <router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
                    <a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" @click.prevent="getCategorie()">Categorie</a>
					<span class="hidden-xs ms-1">\</span>
                    <span class="text-muted ms-1"><Translate :path="'dizionario.base.ELENCO'"></Translate> Categorie</span>
                </h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
            </div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 me-2 position-10" style="text-align: left;" v-if="$root.hasFunzionalita('CATEGORIE_CREATE')" v-on:click="nuovaCategoria()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">
								<Translate :path="'dizionario.base.BTN_NUOVA'"></Translate> Categoria
							</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a v-if="$root.hasFunzionalita('CONF_CATEGORIE_READ')" href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche(34)" title="Opzioni Prodotto" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" @click.prevent="$root.confTravelLingue(34)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" @click.prevent="$root.help(34)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
                </div>
            </div>
        </div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#categorie-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1">Categorie</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>Categorie</span>
							</div>
						</a>
					</li>
				</ul>

				<a class="rounded btn bg-danger bg-opacity-20 btn-sm-light me-2" v-on:click="getCategorie()" v-show="ordineHasChanged">Annulla ordinamento</a>
				<a class="rounded btn bg-success bg-opacity-20 btn-sm-light" v-on:click="salvaOrdinamento()" v-show="ordineHasChanged && $root.hasFunzionalita('CATEGORIE_UPDATE')">Salva ordinamento</a>

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;">Azioni Multiple</span>
								</a>
								<div class="dropdown-menu dropdown-menu-end">
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Stato</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="attivaSelezionati()"><i class="far fa-check-square fa-fw me-2"></i>Attiva selezionati</a>
											<a href="#" class="dropdown-item" @click.prevent="disattivaSelezionati()"><i class="far fa-square fa-fw me-2"></i>Disattiva selezionati</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta dati</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('pagina')">
												<i class="far fa-file-export fa-fw me-2"></i>Pagina corrente
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('selezionati')">
												<i class="far fa-file-export fa-fw me-2"></i>
												<span>Categorie selezionate</span>
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('tutti')">
												<i class="far fa-file-export fa-fw me-2"></i>
												<span>Tutti le Categorie</span>
											</a>
										</div>
									</div>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item" @click.prevent="eliminaSelezionati()"><i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span>Elimina selezionati</a>
								</div>
							</div>
						</li>
						<li class="nav-item">

						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->	

    </div>
    <!-- /page header -->

    <!-- Content area -->
    <div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="categorie-a">
        		<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all" style="">				
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="utente-a">
				                    <div class="row ">
				                  		<div class="col-6 col-md-1 col-lg-1 mbx-1">
				                     		<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Id Categoria" v-model="search.ID_CATEGORIA.VALUE" :tabindex="7" />
				                    	</div>	
			                            <div class="col-6 col-md-1 col-lg-1 mbx-1">
		                                    <select class="form-select form-select-sm" v-model="search.FK_ID_MODULO.VALUE" data-placeholder="Seleziona Modulo" :tabindex="13">
		                                        <option v-bind:value="''">Seleziona Modulo</option>
		                                        <option v-for="modulo in $root.arrayCategorieModuli" v-bind:key="modulo.ID_OPZIONE_TIPOLOGICA"  v-bind:value="modulo.ICONA" > &nbsp; {{modulo.DESCRIZIONE}}</option>
		                                    </select>
			                            </div> 
				                  		<div class="col-5 col-md-2 col-lg-2 mbx-1">
				                     		<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Titolo Categoria" :tabindex="1" v-model="search.DESCRIZIONE.VALUE" />
										</div>               
										<div class="col-12 col-md-5 col-lg-5 mbx-1">
		
		                                </div>	
										<div class="col-12 col-md-1 col-lg-1">
			                                <select class="form-select form-select-sm" data-placeholder="Stato" :tabindex="13" v-model="search.FLG_ATTIVO.VALUE">
			                                    <option value="">Tutti </option>   
			                                    <option value="1"> &nbsp; Attivati</option>
			                                    <option value="0"> &nbsp; Disattivati</option>
			                                </select>
			                            </div>
										<div class="col-6 col-md-1 col-lg-1">
											<SelectLingue 
												class="form-select form-select-sm btn btn-flat-info btn-sm" 
												@change="getCategorie()" 
												v-model="currentLang" 
												style="text-align: left;" 
												:tabindex="4">
											</SelectLingue>
										</div>
									</div>
							 	</form>
							</div>
		          		</div> 
			        </div>
		
			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead" style="min-height: calc(100vh - 392px);">
		               		<table class="table table-bordered table-hover table-striped table-togglable table-width"> 
			                    <thead class="sticky-top">
									<tr class="bg-secondary text-white">
		                                <th class="table-head-sm" style="width:2%;"> 
											<input id="chkAllCategorie" @click.prevent="filters.selectAll('chkAllCategorie',paginatedList.arr)" type="checkbox" class=""> 
										</th>
			                            <th class="table-head-sm" style="width:2%;"> <i class="fa fa-code"></i> </th>
										<th class="table-head-sm" style="width:6%;"> # <ISort class="float-end" v-model="ordinamento" :campo="'ID_CATEGORIA'"></ISort><br /><span class="float-end">Ord. </span></th>
		                                <th class="table-head-sm text-center" style="width:4%;"> Img </th>
		                                <th class="table-head-sm">Titolo Categoria /<br />Sito / SEO</th>
										<th class="table-head-sm" style="width:20%;">Modulo /<br>Visibile in</th>
										<th class="table-head-sm" style="width:15%;">Modello <br /></th>
										<th class="table-head-sm" style="width:5%;">Hits</th>
										<th class="table-head-sm text-center" style="width:5%;">Pubblicato</th>
										<th class="table-head-sm text-center" style="width:5%;">Stato</th>
										<th class="table-head-sm text-center" style="width:5%;">Azioni</th>
		                            </tr>
		                        </thead>
		                        <draggable tag="tbody" @end="ordineChangeHandler($event)" handle=".handle" :animation="150">
		                            <tr v-for="categoria in paginatedList.arr" v-bind:key="categoria.ID_CATEGORIA">
		                                <td class="td-class text-center">
											<span class="footable-toggle"></span>
											<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="categoria.SELEZIONATO" class=""> 
										</td>
		                                <td class="td-class text-center cursor-pointer handle">
											<img src="../../assets/images/icons/arrow.png" width="22" height="22" alt="" />
										</td>
		                                <td class="td-class fs-sm">
											<span>{{categoria.ID_CATEGORIA}}</span><br /> 
											<small class="badge bg-light badge-xs text-muted float-end cursor-pointer" @click="modificaOrdinamento(categoria)">{{ categoria.ORDINE }}</small>
										</td>
		                                <td class="td-class text-center">
											<a href="#" @click.prevent="openUploadCategoria(categoria)" title="Carica immagine - Converti in WebP">
												<img v-if="categoria.ID_CATEGORIA > 0 && categoria.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('CONTENUTO',categoria.URL_AVATAR)" class="squared" style="height: 40px;" alt="" />
												<span v-if="categoria.URL_AVATAR == 'placeholder.jpg'" class="btn-nophoto squared fs-sm" style="width: 40px; height: 40px !important; line-height: 10px; padding-top: 8px; font-size: 0.6rem !important;">No<br />Photo</span>
											</a>
		                                </td>
		                                <td class="td-class fs-sm">
											<span class="text-primary text-uppercase fw-bold cursor-pointer" @click="openOffCanvas();openSchedaVisualizzazioneContenuto(categoria)">{{categoria.DESCRIZIONE}}</span><br /> 	                                   
		                                    <span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;" data-bs-toggle="tooltip" data-bs-placement="top" :title="categoria.ENTI_LABEL"><i class="fal fa-tag fa-fw"></i> {{ categoria.ENTI_LABEL }}</span>
		  									<span @click="updateCategoriaFlgInHome(categoria)" v-show="categoria.FLG_INHOME == 1" class="badge bg-info badge-xs text-white cursor-pointer"><i class="fal fa-home fa-fw"></i> In Home</span>
											<span @click="updateCategoriaFlgInHome(categoria)" v-show="categoria.FLG_INHOME == 0" class="badge bg-light badge-xs text-dark cursor-pointer" style="border: 1px #dddddd solid;"><i class="fal fa-thumbs-up fa-fw"></i> Metti in Home</span>
										</td>
										<td class="td-class fs-sm">
                                            <span class="badge bg-light border-start border-width-3 text-body rounded-start-0 border-info me-1">{{ categoria.MODULO_APPARTENENZA }}</span><br />
                                            <span class="text-muted">{{ categoria.NOME_MODULO }}</span>
                                        </td>
										<td class="td-class fs-sm">
											<div><i class="ph-cube fs-base lh-base align-top text-success me-1"></i><span class="double-items">{{categoria.MODEL}}</span></div>
											<div><i class="ph-calendar fs-base lh-base align-top text-danger me-1"></i> <span class="double-items">{{ filters.formatDateTime(categoria.DATE_ADD,'YYYY-MM-DD HH:mm') }}</span></div>
										</td>
		                                <td class="td-class fs-sm text-center"><span class="badge badge-flat badge-pill border-secondary text-secondary">{{categoria.COUNTER}}</span></td>
										<td class="td-class fs-sm text-center">
											<span @click="updateCategoriaFlgVisibile(categoria)" v-show="categoria.FLG_VISIBILE == 1" class="badge bg-indigo badge-xs text-white cursor-pointer">Pubblico</span>
											<span @click="updateCategoriaFlgVisibile(categoria)" v-show="categoria.FLG_VISIBILE == 0" class="badge bg-pink badge-xs text-white cursor-pointer">Admin</span>
										</td>
		                                <td class="td-class text-center">
		                                    <ISwitch @toggle="updateStatoCategoria(categoria)" :size="'sm'" v-model="categoria.FLG_ATTIVO" style="z-index: 0;"></ISwitch>
		                                </td>
										<td class="td-class text-center">
											<div class="dropdown">
												<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false">
													<i class="ph-list"></i>
												</a>
												<div class="dropdown-menu dropdown-menu-end">
													<div class="dropdown-header text-uppercase font-size-xs line-height-xs">Gestione</div>
													<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('CATEGORIE_UPDATE')" v-on:click="modificaCategoria(categoria)"><i class="fad fa-pencil fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica Categoria</a>
													<a href="#" class="dropdown-item" v-on:click="modificaTesti(categoria)"><i class="fad fa-text fa-fw me-2"></i><span class="text-muted me-1">|</span>Gestione Testi</a>
													<div class="dropdown-divider"></div>
													<a href="#" class="dropdown-item" v-if="categoria.FLG_ELIMINATO != 1 && $root.hasFunzionalita('CATEGORIE_DELETE')" v-on:click="deleteCategoria(categoria)"><i class="fad fa-trash fa-lg fa-fw text-danger me-2"></i><span class="text-muted me-1">|</span>Elimina Categoria</a>
													<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && categoria.FLG_ELIMINATO == 1" v-on:click="eliminaDefinitivamenteCategoria(categoria)"><i class="fad fa-trash fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina definitivamente</a>
													<a href="#" class="dropdown-item text-success" v-if="$root.isGod && categoria.FLG_ELIMINATO == 1" v-on:click="ripristinaCategoria(categoria)"><i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span>Ripristina</a>
	                                            </div>
	                                        </div>
		                                </td>
		                            </tr>
		                        </draggable>
		                    </table>
		                </div>
		
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">RISULTATI ></span>
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2">CATEGORIE: {{ paginatedList.count }}</span> 
                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
									<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
			                    </div>
			                </div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
		                            <option value="5">5</option>
		                            <option value="10">10</option>
		                            <option value="25">25</option>
		                            <option value="50">50</option>
		                            <option value="75">75</option>
		                            <option value="100">100</option>
		                            <option value="250">250</option>
		                            <option value="500">500</option>
		                        </select>
			            	</div>
			        	</div>
					</div>	
		    	</div>
			</div>

        </div>
	</div> 


	<!-- START MODALI --> 	    
    <div class="offcanvas offcanvas-end offcanvas-size-xlg" id="panel_right" data-bs-backdrop="false" role="dialog" tabindex="-1">
		<div class="offcanvas-header bg-info text-white border-0" style="height: 3.95rem;">
			<h5 class="modal-title modal-title-width">
				<i class="ph-list icon-modal-size me-2"></i>SCHEDA CATEGORIA: 
			</h5>  
			<div class="btn-group float-end" :tabindex="2">
				<a href="#" class="badge bg-indigo text-dark p-2 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Comunicazioni</a>
				<div class="dropdown-menu dropdown-position dropdown-menu-end" data-popper-placement="bottom-start" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate3d(0px, 42px, 0px);">
					<a href="#" class="dropdown-item"><i class="fal fa-print fa-fw me-2"></i><span class="text-muted me-1">|</span>Stampa scheda </a>
					<a href="#" class="dropdown-item"><i class="fal fa-envelope fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia email </a>
					<a href="#" class="dropdown-item"><i class="fal fa-paper-plane fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia sms </a>
				</div>
			</div> 	
			<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="offcanvas">
				<i class="ph-x icon-x-size"></i>
			</button>
		</div>
		<div class="offcanvas-body p-2">

			<SchedaVisualizzazioneContenuto @modificaContenuto="openSchedaCategoria($event)" :ref="'schedaVisualizzazioneContenuto'"></SchedaVisualizzazioneContenuto>

		</div>
        <div class="border-top p-1 bg-light">                                
			<button type="button" class="btn btn-link float-end" data-bs-dismiss="offcanvas">
				<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
			</button> 
        </div>  
	</div>

	<div class="modal fade" id="modalNote" role="dialog" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-info text-white border-0">
					<h5 class="modal-title">
						<i class="ph-list icon-modal-size me-2"></i><span class="me-2">Categoria:</span>{{ categoriaSelezionata.DESCRIZIONE }}  
					</h5>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal">
						<i class="ph-x icon-x-size"></i>
					</button>
				</div>
				<div class="modal-body" style="height: 15rem;">

					<h6 class="fw-semibold mb-1">
						<i class="ph-info me-2"></i>Note Importanti:
					</h6>
					<hr />

					<div class="textarea rounded" v-html="categoriaSelezionata.NOTE"></div>

				</div>
				<div class="modal-footer bg-light p-1">                                
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
				</div>
			</div>
		</div>
	</div> 
	    
    <SchedaContenuto :ref="'schedaContenuto'" @updateGriglia="getCategorie()" :modalita="2" :currentLang="currentLang"></SchedaContenuto>

	<PopupOrdinamento @ordinamentoAggiornato="handlerOrdinamentoAggiornato($event)" :ref="'modalOrdinamento'"></PopupOrdinamento>

    <AvatarUploader ref="avatarUpd" folder="CONTENUTO" title="Immagine Categoria" modalId="popUpUploadAvatarCategoria" @uploaded="onAvatarUploaded"></AvatarUploader>

</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
import SchedaContenuto from '@/components/SchedaContenuto.vue'
import ISort from '@/components/utils/ISort.vue'
import { VueDraggableNext } from 'vue-draggable-next'
import SchedaVisualizzazioneContenuto from '@/components/SchedaVisualizzazioneContenuto.vue'
import PopupOrdinamento from '@/components/utils/PopupOrdinamento.vue'
import AvatarUploader from '@/components/utils/AvatarUploader.vue'
import SelectLingue  from '@/components/utils/SelectLingue.vue'


export default {
    name:"Categorie",
	 
    emits:['updateGriglia'],

    components:{
        Pagine,
        ISwitch,
		ISort,
        SchedaContenuto,
        draggable: VueDraggableNext,
		SchedaVisualizzazioneContenuto,
		PopupOrdinamento,
        AvatarUploader,
		SelectLingue,

    },

    data: function (){
      	return{
            apiStartup:'shared/categorie',
	        filters:global.filters,	
            GLOBAL_IMAGES_PATH:'',
	        arrayCategorie:new Array(),
            categoriaSelezionata:{enti:new Array()},
            categoriaCorrente:{},			
			categoriaLangSelezionato:{},
            arrayCampiPopUpCategorie : new Array(),
	        search:{
	            PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
                ID_CATEGORIA:{TYPE:'TEXT',VALUE:''},
	            DESCRIZIONE:{TYPE:'TEXT',VALUE:''},	
	            FLG_ATTIVO:{TYPE:'COMBO',VALUE:'1'}, 
				FK_ID_MODULO:{TYPE:'COMBO',VALUE:''}
	        },
			ordinamento:'',
			rs : utils.generateRandomString(30),
            arrayModuli : new Array(),
			ordineHasChanged: false,
			currentLang:0,
      	}
		
    },

    methods: {

        getCategorie: function () {
            utils.get(this.apiStartup,{}, (response) => {
				this.ordineHasChanged = false;
                this.arrayCategorie = response.data;
				this.arrayModuli = new Array();

				for (let i = 0 ; i < this.arrayCategorie.length ; i++){
					var moduloAppartenenza = utils.array.select(this.$root.arrayTipoModuli,'ICONA',this.arrayCategorie[i].FK_ID_MODULO,1)[0];
					this.arrayCategorie[i].MODULO_APPARTENENZA = moduloAppartenenza.DESCRIZIONE;
                    this.arrayCategorie[i].MODULI = new Array();
					var arrayModuli = this.arrayCategorie[i].NOME_MODULO ? this.arrayCategorie[i].NOME_MODULO.split(",") : new Array();
					var arrayId = this.arrayCategorie[i].ID_MODULI ? this.arrayCategorie[i].ID_MODULI.split(",") : new Array();
					var arrayFinale = new Array();
					for (var j = 0 ; j < arrayModuli.length ; j++){
						arrayFinale.push({FK_ID_MODULO:arrayId[j],DESCRIZIONE:arrayModuli[j]});
						var check = 0;
						for (var k = 0 ; k < this.arrayModuli.length ; k++){
							if (this.arrayModuli[k].FK_ID_MODULO == arrayId[j]){
								check = 1;
								break;
							}
						}
						if (check == 0){
							this.arrayModuli.push({FK_ID_MODULO:arrayId[j],DESCRIZIONE:arrayModuli[j]});
						}
					}
					this.arrayCategorie[i].MODULI = arrayFinale;
                }
				
            }); 
        },		

        nuovaCategoria : function(){
            this.$refs.schedaContenuto.startup({ID_CATEGORIA:0,FLG_ATTIVO:1});
        },

        modificaCategoria : function(categoria){            
            this.categoriaSelezionata = utils.clone(categoria);
            this.$refs.schedaContenuto.startup(categoria);
        },

        modificaTesti : function(categoria){
            this.categoriaSelezionata = utils.clone(categoria);
            this.$root.contenuto = {ID_CONTENUTO: categoria.FK_ID_CONTENUTO, FK_ID_MODULO: categoria.FK_ID_MODULO};
            global.router.push({name:'ContenutiLang', query:{modalita:2, modulo:categoria.FK_ID_MODULO, back:'Categorie'}});
        },

        salvaCategoria : function(){
            var api = this.categoriaSelezionata.ID_CATEGORIA > 0 ? "shared/categoria/update" : "shared/categoria/insert";
            utils.ajax(api,this.categoriaSelezionata, (response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    if (this.categoriaSelezionata.ID_CATEGORIA == 0){
                        this.categoriaSelezionata.ID_CATEGORIA = response.id_inserito;
                    }
                    utils.ajax('shared/categorie/singola',this.categoriaSelezionata, (response) => {                        
                        //this.filters.closePopUp("popUpCategoria");
                        utils.get('shared/categorie',{}, (response) => {
                            this.arrayCategorie = response.data;
                        });
                    }); 
                }
            });
        },  

        updateStatoCategoria : function(categoria){
            setTimeout(() => {
                utils.put('shared/categorie/stato/update',categoria, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
                        this.filters.closePopUp("popUpCategoria");
                    }  
                }); 
            },250);
        },

        deleteCategoria : function(t){
            utils.alert.confirm("Sicuro di voler eliminare questa Categoria " + t.NOME + "?",()=>{
                utils.ajax('shared/categoria/delete',{ID_CATEGORIA:t.ID_CATEGORIA}, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
                        this.getCategorie();
                    }
                });
            },this.$root);
        }, 
	
		eliminaDefinitivamenteCategoria(categoria) {
			utils.alert.confirm('Eliminare definitivamente questa Categoria ' + categoria.NOME + '?', () => {
				utils.ajax('shared/categoria/harddelete', { ID_CATEGORIA: categoria.ID_CATEGORIA }, (r) => {
					if (r.esito == 0) { this.getCategorie(); utils.alert.success(r.messaggio); }
				});
			}, this.$root);
		},

		ripristinaCategoria(categoria) {
			utils.ajax('shared/categoria/ripristina', { ID_CATEGORIA: categoria.ID_CATEGORIA }, (r) => {
				if (r.esito == 0) { this.getCategorie(); utils.alert.success('Utente ripristinato.'); }
			});
		},

		updateCategoriaFlgVisibile : function(categoria){
			categoria.FLG_VISIBILE = categoria.FLG_VISIBILE == 1 ? 0 : 1;
			utils.ajax("shared/categoria/update",categoria, (response) => {
				if (response.esito == 0){
					utils.alert.success(response.messaggio);
				}
				else{
					categoria.FLG_VISIBILE = categoria.FLG_VISIBILE == 1 ? 0 : 1;
				}
            });
        },

		updateCategoriaFlgInHome : function(categoria){
			categoria.FLG_INHOME = categoria.FLG_INHOME == 1 ? 0 : 1;
			utils.ajax("shared/categoria/update",categoria, (response) => {
				if (response.esito == 0){
					utils.alert.success(response.messaggio);
				}
				else{
					categoria.FLG_INHOME = categoria.FLG_INHOME == 1 ? 0 : 1;
				}
			});                
        },

        esportazione : function(formato){
            utils.report.token({modalita:'esportaCategorie',formato:formato});
        },

		ordineChangeHandler : function(event){
			this.arrayCategorie = this.filters.draggableChangeHandler(event,this.arrayCategorie,this.search,"ID_CATEGORIA");
			this.ordineHasChanged = true;		
		},	 

		salvaOrdinamento : function(){
			utils.alert.confirm("Sei sicuro di voler salvare l'ordinamento?",()=>{
				var arr = new Array();			
				for (var i = 0 ; i < this.arrayCategorie.length ; i++){
					arr.push({"ID": this.arrayCategorie[i].ID_CATEGORIA,"O": this.arrayCategorie[i].ORDINE});
				}			
				utils.ajax('shared/peso/update',{CLASS:'Categoria',items:arr}, (response) => {
					if (response.esito == 0){
						utils.alert.success(response.messaggio);
						this.getCategorie();
						this.ordineHasChanged = false;
					}
				});
			},this.$root);
		},

        openUploadCategoria : function(categoria){
            this.categoriaCorrente = categoria;
            this.$refs.avatarUpd.open({id: categoria.ID_CATEGORIA, url: categoria.URL_AVATAR});
        },

        onAvatarUploaded : function(nomeAvatar){
            this.categoriaCorrente.URL_AVATAR = nomeAvatar;
            utils.ajax("shared/categoria/update",this.categoriaCorrente, (response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    this.getCategorie();
                }
                else if (response.messaggio){
                    utils.alert.warning(response.messaggio);
                }
            });
        },

        openSchedaCategoria: function(contenuto){
            this.$refs.schedaContenuto.startup(this.categoriaSelezionata);
        },
        

		openOffCanvas : function(){
			var myOffcanvas = document.getElementById('panel_right')
			var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
			bsOffcanvas.show();
		},

		openSchedaVisualizzazioneContenuto : function(categoria){
			this.categoriaSelezionata = utils.clone(categoria);	
			this.$refs.schedaVisualizzazioneContenuto.openSchedaVisualizzazioneContenuto(categoria,1);
		},

		modificaOrdinamento : function(categoria){
			this.$refs.modalOrdinamento.openPopUpOrdinamento(categoria,this.arrayCategorie,"ID_CATEGORIA");
		},
		
		handlerOrdinamentoAggiornato : function(_array){
			this.arrayCategorie = utils.clone(_array);
			this.salvaOrdinamento();
		}
       
    },

    computed: {
        paginatedList(){
            var arr = utils.inGrid(this.arrayCategorie,this.search, this.ordinamento);
            return arr;
        },

/*
		getTotali(){
            var filtrato = global.utils.filter(this.arrayUtenti,this.search);
            var totale = 0;
            var fatturato = 0;
            for (var i = 0 ; i < filtrato.length ; i++){
                totale += parseFloat(filtrato[i]);
                fatturato += parseFloat(filtrato[i]);
            }
            return {
                LORDO:lordo,
                COMM:comm,
                NETTO:lordo-comm,
                COUNT:filtrato.length
            }
        }
*/

	},

    created: function () {
        global.utils.BASE_API = process.env.VUE_APP_API_URL;
        this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
        this.arrayModuli = utils.array.toSelect2(this.$root.arrayTipoModuli,"ID_OPZIONE_TIPOLOGICA","DESCRIZIONE");
        this.categoriaCorrente = utils.clone(this.$root.categoria);
		this.currentLang = this.$root.currentLang;
		/*
        utils.get(this.apiStartup,{}, (response) => {
		   this.ordineHasChanged = false;
           this.arrayCategorie = response.data;
        });*/
		this.getCategorie();
    }

}
</script> 

